export const SIGNAL_META = {
  STRONG_BUY: { label: "STRONG BUY", color: "#065F46", bg: "#ECFDF5", border: "#10B981", icon: "▲" },
  STRONG_SHORT: { label: "STRONG SHORT", color: "#991B1B", bg: "#FEF2F2", border: "#EF4444", icon: "▼" },
  MONITOR_BUY: { label: "WATCH · BUY", color: "#1E40AF", bg: "#EFF6FF", border: "#60A5FA", icon: "◆" },
  MONITOR_SHORT: { label: "WATCH · SHORT", color: "#92400E", bg: "#FFFBEB", border: "#F59E0B", icon: "◆" },
  NEUTRAL: { label: "NEUTRAL", color: "#475569", bg: "#F8FAFC", border: "#CBD5E1", icon: "●" },
};

export const UP = "#00873C";
export const DOWN = "#D32F2F";

export const sigMeta = (s) => SIGNAL_META[s] || SIGNAL_META.NEUTRAL;

export const fmt = (v, d = 2) =>
  v === null || v === undefined || Number.isNaN(v) ? "—" : Number(v).toFixed(d);

export const cur = (m) => (m === "IN" ? "₹" : "$");

export const pct = (v, d = 1) =>
  v === null || v === undefined ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(d)}%`;

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
